import React from "react";
import logger from "logger";
import Header from "Common/Header";
import Toolbar from "./Toolbar";
import Grid from "@material-ui/core/Grid";
import { useSelector } from "react-redux";
import store from "store";
import Constants from "Utils/Constants";
import { getData } from "Utils/Common";
import Tasklet from "./Tasklet";

export const openTaskHistory = (user, server, account, history) => {
  const accountdetailrow = {
    account,
    server,
  };
  const dataparams = {
    accountdetail: accountdetailrow,
    datakey: "taskhistory",
  };
  store.dispatch({ type: "ISLOADING", payload: true });
  return getData(dataparams, ({ data: { ok, data } }) => {
    if (ok) {
      store.dispatch({
        type: "UPDATEACCOUNTDETAIL",
        payload: { taskhistory: data.taskhistory },
      });
    }
  })
    .then(() => {
      history &&
        history.push({
          pathname: Constants.taskhistory,
        });
      store.dispatch({ type: "ISLOADING", payload: false });
    })
    .catch((err) => {
      console.error(err);
      store.dispatch({ type: "ISLOADING", payload: false });
    });
};

export const TaskHistory = (props) => {
  const accountdetail = useSelector(({ rootScope }) => rootScope.accountdetail);
  const { taskhistory } = accountdetail;
  logger.log(accountdetail, taskhistory, "aha");

  return (
    <div>
      <Header />
      <br />
      <Toolbar AccountDetailData={accountdetail} />
      <div className="komform">
        <Grid container spacing={1}>
          {taskhistory &&
            taskhistory.map((task) => {
              /*
              if (task.taskstatus !== "Completed") {
                return null;
              }
              */
              return (
                <Grid item key={task.taskid}>
                  <Tasklet task={task} />
                </Grid>
              );
            })}
        </Grid>
      </div>
    </div>
  );
};
